/* ==========================================================
   BOOSTRCLUB — ATC Success Animation
   Passe le bouton au vert après ajout au panier réussi
   ========================================================== */
(function () {
  'use strict';

  var SUCCESS_COLOR = '#10B981';
  var SUCCESS_TEXT = 'Ajouté !';
  var SUCCESS_DURATION = 2000;

  /* ── Observe les boutons ATC du thème (aria-busy) ─────── */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type !== 'attributes' || m.attributeName !== 'aria-busy') return;
      var btn = m.target;
      /* Quand aria-busy passe de true à false = ajout terminé */
      if (btn.getAttribute('aria-busy') === 'false' && btn._brcWasBusy) {
        btn._brcWasBusy = false;
        showSuccess(btn);
      }
      if (btn.getAttribute('aria-busy') === 'true') {
        btn._brcWasBusy = true;
      }
    });
  });

  /* ── Observe le body pour attraper tous les boutons ────── */
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-busy'],
    subtree: true
  });

  /* ── Animation de succès sur le bouton principal (page produit, sticky, quick view) ── */
  function showSuccess(btn) {
    if (!btn.matches('[name="add"], .hdt-product-form__submit, .hdt-btn-accent')) return;
    if (btn.classList.contains('brc-atc-success')) return;

    /* Sauvegarder le texte original */
    var textEl = btn.querySelector('.hdt-btn-atc_text, .hdt-truncate, span:not(.sr-only):not(.hdt-loading__spinner):not(.hdt-pr-card-icon)');
    var originalText = textEl ? textEl.textContent : '';
    var originalBg = btn.style.cssText;

    btn.classList.add('brc-atc-success');
    if (textEl) textEl.textContent = SUCCESS_TEXT;

    setTimeout(function () {
      btn.classList.remove('brc-atc-success');
      if (textEl) textEl.textContent = originalText;
      btn.style.cssText = originalBg;
    }, SUCCESS_DURATION);
  }

  /* ── Animation de succès sur les boutons cards (collections, recherche) ── */
  /* Ces boutons n'utilisent pas aria-busy, on écoute l'event cart:update */
  document.addEventListener('cart:update', function (e) {
    if (!e.detail || !e.detail.source) return;
    /* source = "product-form-component" pour les ajouts depuis les cards */
    var sourceId = e.detail.sourceId;
    if (!sourceId) return;

    var form = document.getElementById(sourceId);
    if (!form) return;

    var cardBtn = form.querySelector('.hdt-card-product__btn-ultra[type="submit"]');
    if (!cardBtn) return;
    if (cardBtn.classList.contains('brc-atc-success')) return;

    cardBtn.classList.add('brc-atc-success');
    setTimeout(function () {
      cardBtn.classList.remove('brc-atc-success');
    }, SUCCESS_DURATION);
  });
})();
